export const ModalTypesEnum = {
  DOCUMENT_REQUEST: "DOCUMENT_REQUEST",
  DELIVERY_FEE_REQUEST: "DELIVERY_FEE_REQUEST",
  DELIVERY_FEE_EDIT_REQUEST: "DELIVERY_FEE_EDIT_REQUEST",
  CHAT_USER_FETCH_REQUEST: "CHAT_USER_FETCH_REQUEST",
};

export default ModalTypesEnum;
